@if (mode === "inline") {
<section
  class="rounded-lg border border-borders-dark dark:border-black-dark-lighter overflow-hidden mt-4 mb-3 bg-whitepale dark:bg-black-dark-light"
>
  <div
    class="flex items-center justify-between gap-3 p-2 border-b border-borders-dark dark:border-black-dark-lighter"
  >
    <div class="flex items-center gap-2">
      <span
        class="block w-[24px] h-[24px] bg-grey dark:bg-borders-dark/80 mask-[url(/assets/images/icons/friends.svg)] mask-size-[24px_24px]"
      ></span>
      <h3
        class="font-base font-bold mb-0 text-sm uppercase text-grey dark:text-borders-dark"
      >
        {{ titleKey | translate }}
      </h3>
    </div>

    <button
      class="btn btn-small btn-transparent !rounded-full"
      (click)="openAddModal()"
    >
      + {{ "ADD" | translate }}
    </button>
  </div>

  @if (companions.length > 0) {
  <div class="px-2">
    @for (companion of companions; track companion._id) {
    <div
      class="flex items-center justify-between gap-2 py-2 border-b border-borders-dark/70 dark:border-black-dark-lighter/80 last:border-b-0"
    >
      <div class="flex items-center gap-3 min-w-0">
        <app-user-avatar
          [name]="getCompanionDisplayName(companion)"
          [picture]="companion.target.picture"
          [size]="42"
        ></app-user-avatar>

        <div class="min-w-0">
          <div class="flex items-center gap-2 min-w-0">
            <div class="font-bold truncate">
              {{ getCompanionDisplayName(companion) }}
            </div>
            @if (isLocalCompanion(companion)) {
            <span
              class="tag shrink-0 bg-black/10 text-grey dark:bg-white/10 dark:text-borders-dark"
            >
              {{ "LOCAL_FRIEND" | translate }}
            </span>
            }
          </div>
          @if (canToggleSync(companion) && companion.syncEnabled) {
          <div
            class="text-sm text-completed flex justify-start items-center gap-1"
          >
            <div class="w-1 h-1 bg-completed rounded-full"></div>
            {{ "SYNC_ACTIVE" | translate }}
          </div>
          } @else if (canToggleSync(companion)) {
          <div
            class="text-sm text-grey dark:text-borders-dark flex justify-start items-center gap-1"
          >
            <div
              class="w-1 h-1 bg-grey dark:bg-borders-dark rounded-full"
            ></div>
            {{ "SYNC_DISABLED" | translate }}
          </div>
          @if (isCompanionSyncDisabledBecauseCompleted(companion)) {
          <div class="text-xs font-bold text-primary-text mt-1">
            {{ "WORKS_COMPANION_SYNC_COMPLETED_DISABLED" | translate }}
          </div>
          } }
        </div>
      </div>

      <div class="flex items-center gap-3 shrink-0 relative z-10">
        @if (canToggleSync(companion)) {
        <mat-slide-toggle
          class="works-companion-sync-toggle"
          labelPosition="before"
          [ngModel]="companion.syncEnabled"
          [disabled]="
            !companion.syncEnabled && !canEnableCompanionSync(companion)
          "
          (ngModelChange)="toggleSync(companion)"
        >
          Sync
        </mat-slide-toggle>
        }
        <button
          type="button"
          class="relative z-20 shrink-0 w-[30px] h-[30px] rounded-full bg-black/10 dark:bg-white/10 text-grey dark:text-borders-dark"
          (click)="removeCompanion(companion)"
        >
          <span
            class="block w-[12px] h-[12px] m-[9px] bg-black dark:bg-borders-dark mask-[url(/assets/images/icons/close.svg)] mask-size-[12px_12px]"
          ></span>
        </button>
      </div>
    </div>
    }
  </div>
  } @else {
  <div class="p-3 text-center">
    <div class="opacity-30 mb-2">
      <span
        class="block w-[48px] h-[48px] m-auto bg-grey dark:bg-borders-dark/80 mask-[url(/assets/images/icons/friends.svg)] mask-size-[48px_48px]"
      ></span>
    </div>
    <p class="text-grey mt-0 mb-0.5">
      {{ "WORKS_COMPANION_EMPTY_TITLE" | translate }}
    </p>
    <p class="text-grey mt-0 mb-2">
      {{ "WORKS_COMPANION_EMPTY_TEXT" | translate }}
    </p>
    <button
      class="btn btn-grad btn-small !rounded-full m-auto"
      (click)="openAddModal()"
    >
      {{ "LINK_A_FRIEND" | translate }}
    </button>
  </div>
  }
</section>
} @if (mode === "modalContent") {
<div class="flex h-full min-h-0 flex-col">
  <div class="mb-3 shrink-0">
    <div class="mb-2 text-sm uppercase text-grey dark:text-borders-dark">
      @if (modalStep === 1) {
      {{ "WORKS_COMPANION_STEP_1" | translate }}
      } @else if (modalStep === 2) {
      {{ "WORKS_COMPANION_STEP_2" | translate }}
      } @else {
      {{ "WORKS_COMPANION_STEP_3" | translate }}
      }
    </div>

    <div class="mb-3 grid grid-cols-3 gap-2">
      <div
        class="h-[3px] rounded-full"
        [ngClass]="
          modalStep >= 1 ? 'bg-completed' : 'bg-black/10 dark:bg-white/10'
        "
      ></div>
      <div
        class="h-[3px] rounded-full"
        [ngClass]="
          modalStep > 2
            ? 'bg-completed'
            : modalStep === 2
            ? 'bg-primary'
            : 'bg-black/10 dark:bg-white/10'
        "
      ></div>
      <div
        class="h-[3px] rounded-full"
        [ngClass]="
          modalStep >= 3 ? 'bg-primary' : 'bg-black/10 dark:bg-white/10'
        "
      ></div>
    </div>

    @if (modalStep === 1) {
    <div class="flex items-start justify-between gap-3">
      <div>
        <h2 class="!m-0 !mb-1 !max-w-none">{{ flowTitleKey | translate }}</h2>
        <div class="text-grey dark:text-borders-dark">
          {{ worksService.getItemTitle(item) }}
        </div>
      </div>
      <div class="font-bold text-primary-text dark:text-primary">
        {{ selectedCount }} {{ selectedCountLabel | translate }}
      </div>
    </div>
    } @else if (modalStep === 2) {
    <div class="flex items-center gap-3">
      <button
        class="h-[36px] w-[36px] rounded-full bg-black/10 dark:bg-white/10"
        (click)="backToSelectionStep()"
      >
        &larr;
      </button>
      <div>
        <h2 class="!m-0 !mb-0 max-w-none">
          {{ "NEW_LOCAL_FRIEND" | translate }}
        </h2>
        <div class="text-grey dark:text-borders-dark">
          {{ "WORKS_COMPANION_NEW_FRIEND_TEXT" | translate }}
        </div>
      </div>
    </div>
    } @else {
    <div class="flex items-center gap-3">
      <button
        class="h-[36px] w-[36px] rounded-full bg-black/10 dark:bg-white/10"
        (click)="backToSyncSelectionStep()"
      >
        &larr;
      </button>
      <div>
        <h2 class="!m-0 !mb-0 max-w-none">
          {{ "WORKS_COMPANION_SYNC_TITLE" | translate }}
        </h2>
        <div class="text-grey dark:text-borders-dark">
          {{ "WORKS_COMPANION_SYNC_TEXT" | translate }}
        </div>
      </div>
    </div>
    }
  </div>

  @if (modalStep === 1) {
  <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
    <form
      class="modalSearch relative !m-0 !mb-2 w-full shrink-0"
      (submit)="$event.preventDefault()"
    >
      <span
        class="icon pointer-events-none"
        style="
          -webkit-mask: url(&quot;/assets/images/icons/search.svg&quot;);
          mask: url(&quot;/assets/images/icons/search.svg&quot;);
          -webkit-mask-size: 28px 28px;
          mask-size: 28px 28px;
        "
      ></span>
      <input
        [(ngModel)]="searchTerm"
        class="search !mb-0"
        [placeholder]="'WORKS_COMPANION_SEARCH' | translate"
        autocomplete="off"
        name="worksCompanionSearch"
      />
    </form>

    <div class="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden">
      <button
        class="works-companion-flat-action shrink-0"
        (click)="openNewLocalFriendStep()"
      >
        <div
          class="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full border border-dashed border-borders-dark/70 text-lg text-grey dark:border-white/20 dark:text-borders-dark"
        >
          +
        </div>
        <div class="min-w-0 text-left">
          <div class="font-bold text-black dark:text-white">
            {{ "WORKS_COMPANION_ADD_NEW_FRIEND" | translate }}
          </div>
          <div class="text-sm text-grey dark:text-borders-dark">
            {{ "WORKS_COMPANION_ADD_NEW_FRIEND_SUBTITLE" | translate }}
          </div>
        </div>
      </button>

      <div class="works-companion-step-one-scroll">
        @if (hasRecentFriendsSection) {
        <section class="flex flex-col pb-2">
          <div class="mb-2 flex items-start justify-between gap-3">
            <div
              class="text-s font-bold uppercase text-grey dark:text-borders-dark"
            >
              {{ "RECENTS" | translate }}
            </div>
            @if (hiddenRecentFriendsCount > 0) {
            <div class="text-right text-xs text-grey dark:text-borders-dark">
              {{
                "WORKS_COMPANION_SEARCH_MORE_HINT"
                  | translate
                    : {
                        count: hiddenRecentFriendsCount
                      }
              }}
            </div>
            }
          </div>

          @if (visibleRecentFriends.length > 0) {
          <div class="works-companion-step-one-list">
            <div class="works-companion-step-one-grid">
              @for (friend of visibleRecentFriends; track friend._id) {
              <button
                class="works-companion-choice"
                [ngClass]="{
                  'is-selected': isFriendSelected(friend._id)
                }"
                (click)="toggleFriendSelection(friend._id)"
              >
                <div class="flex min-w-0 items-center gap-2">
                  <app-user-avatar
                    [name]="friend.displayNameOverride || friend.username"
                    [picture]="friend.picture"
                    [size]="36"
                  ></app-user-avatar>
                  <div class="min-w-0 text-left">
                    <div class="truncate font-bold text-black dark:text-white">
                      {{ friend.displayNameOverride || friend.username }}
                    </div>
                    <div class="text-xs text-grey dark:text-borders-dark">
                      {{ getSelectedFriendWorksCount(friend) }}
                      {{ getSelectedFriendWorksCountLabel(friend) | translate }}
                    </div>
                  </div>
                </div>
                <div
                  class="works-companion-check"
                  [ngClass]="{
                    'is-selected': isFriendSelected(friend._id)
                  }"
                >
                  <span
                    class="block h-[14px] w-[14px] bg-black mask-[url(/assets/images/icons/check.svg)] mask-size-[14px_14px]"
                    [ngClass]="{
                      'opacity-100': isFriendSelected(friend._id),
                      'opacity-0': !isFriendSelected(friend._id)
                    }"
                  ></span>
                </div>
              </button>
              }
            </div>
          </div>
          }
        </section>
        } @if (hasLocalFriendsSection || shouldShowNoLocalFriends) {
        <section
          class="flex flex-col pt-2"
          [ngClass]="{
            'border-t border-borders-dark/70 dark:border-black-dark-lighter/80':
              hasRecentFriendsSection
          }"
        >
          <div class="mb-2 flex items-start justify-between gap-3">
            <div
              class="text-s font-bold uppercase text-grey dark:text-borders-dark"
            >
              {{ "LOCAL_FRIENDS" | translate }}
            </div>
            @if (hiddenLocalUsersCount > 0) {
            <div class="text-right text-xs text-grey dark:text-borders-dark">
              {{
                "WORKS_COMPANION_SEARCH_MORE_HINT"
                  | translate
                    : {
                        count: hiddenLocalUsersCount
                      }
              }}
            </div>
            }
          </div>

          @if (visibleLocalUsers.length > 0) {
          <div class="works-companion-step-one-list">
            <div class="works-companion-step-one-grid">
              @for (localUser of visibleLocalUsers; track localUser._id) {
              <button
                class="works-companion-choice"
                [ngClass]="{
                  'is-selected': isLocalUserSelected(localUser._id)
                }"
                (click)="toggleLocalUserSelection(localUser._id)"
              >
                <div class="flex min-w-0 items-center gap-2">
                  <app-user-avatar
                    [name]="localUser.displayNameOverride || localUser.pseudo"
                    [size]="36"
                  ></app-user-avatar>
                  <div class="min-w-0 text-left">
                    <div class="truncate font-bold text-black dark:text-white">
                      {{ localUser.displayNameOverride || localUser.pseudo }}
                    </div>
                    <div class="text-xs text-grey dark:text-borders-dark">
                      {{ "LOCAL_FRIEND" | translate }}
                    </div>
                  </div>
                </div>
                <div
                  class="works-companion-check"
                  [ngClass]="{
                    'is-selected': isLocalUserSelected(localUser._id)
                  }"
                >
                  <span
                    class="block h-[14px] w-[14px] bg-black mask-[url(/assets/images/icons/check.svg)] mask-size-[14px_14px]"
                    [ngClass]="{
                      'opacity-100': isLocalUserSelected(localUser._id),
                      'opacity-0': !isLocalUserSelected(localUser._id)
                    }"
                  ></span>
                </div>
              </button>
              }
            </div>
          </div>
          } @else if (shouldShowNoLocalFriends) {
          <div class="mb-3 text-sm text-grey">
            {{ "NO_LOCAL_FRIENDS" | translate }}
          </div>
          }
        </section>
        }
      </div>
    </div>

    <div
      class="sticky bottom-1 z-20 shrink-0 -mx-2 bg-white/90 px-2 py-2 backdrop-blur-sm dark:bg-black-dark/90 mobile:-mx-6 mobile:px-6"
    >
      <button
        class="btn btn-grad w-full !block !max-w-none"
        [disabled]="!canSubmitSelection"
        (click)="continueFromSelection()"
      >
        {{ "WORKS_COMPANION_CONFIRM_SELECTION" | translate }}
      </button>
    </div>
  </div>
  } @else if (modalStep === 2) {
  <div class="min-h-0 flex-1 overflow-y-auto pr-1">
    <app-local-friend-form
      [(pseudo)]="newLocalPseudo"
      [email]="newLocalEmail"
      (emailChange)="onLocalEmailInput($event)"
      [sendInvitation]="sendInvitation"
      (sendInvitationChange)="onInvitationToggleChange($event)"
      [isEmailValid]="isNewLocalEmailValid"
      [canSubmit]="canSubmitNewLocalFriend"
      submitLabelKey="CREATE_AND_LINK"
      (submitForm)="continueFromNewFriend()"
    ></app-local-friend-form>
  </div>
  } @else {
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="min-h-0 flex-1 overflow-y-auto overflow-x-hidden pr-1">
      @for (friend of selectedFriends; track friend._id) {
      <div
        class="flex min-w-0 items-center justify-between gap-3 py-3 border-b border-borders-dark/70 dark:border-black-dark-lighter/80 last:border-b-0"
      >
        <div class="flex min-w-0 items-center gap-3">
          <app-user-avatar
            [name]="friend.displayNameOverride || friend.username"
            [picture]="friend.picture"
            [size]="42"
          ></app-user-avatar>
          <div class="min-w-0">
            <div class="truncate font-bold">
              {{ friend.displayNameOverride || friend.username }}
            </div>
            <div
              class="text-sm"
              [ngClass]="
                isSyncSelectionEnabled(friend._id)
                  ? 'text-completed'
                  : 'text-grey dark:text-borders-dark'
              "
            >
              {{
                (isSyncSelectionEnabled(friend._id)
                  ? "SYNC_ACTIVE"
                  : "SYNC_DISABLED"
                ) | translate
              }}
            </div>
            @if (isSyncDisabledBecauseCompleted(friend._id)) {
            <div class="text-xs font-bold text-primary-text mt-1 max-w-[280px]">
              {{ "WORKS_COMPANION_SYNC_COMPLETED_DISABLED" | translate }}
            </div>
            }
          </div>
        </div>
        <div class="flex items-center gap-2">
          <mat-slide-toggle
            class="works-companion-sync-toggle"
            labelPosition="before"
            [ngModel]="isSyncSelectionEnabled(friend._id)"
            [disabled]="!canEnableSyncSelection(friend._id)"
            (ngModelChange)="toggleSyncSelection(friend._id)"
          >
            Sync
          </mat-slide-toggle>
        </div>
      </div>
      } @if (selectedLocalUsers.length > 0 || hasPendingNewLocalFriend) {
      <div class="mt-4">
        <div
          class="text-s font-bold uppercase text-grey dark:text-borders-dark mb-2"
        >
          {{ "LOCAL_FRIENDS" | translate }}
        </div>

        @for (localUser of selectedLocalUsers; track localUser._id) {
        <div
          class="flex min-w-0 items-center justify-between gap-3 py-3 border-b border-borders-dark/70 dark:border-black-dark-lighter/80 last:border-b-0"
        >
          <div class="flex items-center gap-3 min-w-0">
            <app-user-avatar
              [name]="localUser.displayNameOverride || localUser.pseudo"
              [size]="42"
            ></app-user-avatar>
            <div class="min-w-0">
              <div class="font-bold truncate">
                {{ localUser.displayNameOverride || localUser.pseudo }}
              </div>
              <div class="text-sm text-grey dark:text-borders-dark">
                {{ "LOCAL_FRIEND" | translate }}
              </div>
            </div>
          </div>
          <div
            class="max-w-[150px] shrink text-right text-sm text-grey dark:text-borders-dark"
          >
            {{ "WORKS_COMPANION_LINK_ON_CONFIRM" | translate }}
          </div>
        </div>
        } @if (hasPendingNewLocalFriend) {
        <div
          class="flex min-w-0 items-center justify-between gap-3 py-3 border-b border-borders-dark/70 dark:border-black-dark-lighter/80 last:border-b-0"
        >
          <div class="flex items-center gap-3 min-w-0">
            <app-user-avatar
              [name]="pendingNewLocalFriendName"
              [size]="42"
            ></app-user-avatar>
            <div class="min-w-0">
              <div class="font-bold truncate">
                {{ pendingNewLocalFriendName }}
              </div>
              <div class="text-sm text-grey dark:text-borders-dark">
                {{ "LOCAL_FRIEND" | translate }}
              </div>
            </div>
          </div>
          <div
            class="max-w-[150px] shrink text-right text-sm text-grey dark:text-borders-dark"
          >
            {{ "WORKS_COMPANION_CREATE_AND_LINK_ON_CONFIRM" | translate }}
          </div>
        </div>
        }
      </div>
      }

      <div
        class="mt-5 rounded-lg border border-borders-dark p-2 dark:border-black-dark-lighter mobile:p-3"
      >
        <div
          class="text-s font-bold uppercase text-grey dark:text-borders-dark mb-2"
        >
          {{ "WORKS_COMPANION_ABOUT" | translate }}
        </div>
        <div class="text-grey dark:text-borders-dark">
          {{ "WORKS_COMPANION_SYNC_HELP" | translate }}
        </div>
      </div>
    </div>

    <button
      class="btn btn-grad w-full !block !max-w-none mt-4"
      (click)="submitSelections()"
    >
      {{ "WORKS_COMPANION_START" | translate }}
    </button>
  </div>
  }
</div>
}
